import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import VolumeSlider from './volume-slider';
import MuteToggleButton from './mute-toggle-button';
/*
  Volume Controller

  A Wrapper for the Volume Slider and the Mute Toggle Button
*/
export default class VolumeController extends React.Component{
    constructor(props){
        super(props);
    }
    shouldComponentUpdate(nextProps, nextState){
        return false;
    }
    componentDidMount() {
    }

    render() {
      const VolumeWrapProps = {
        className: cx({
          'volume-wrap': true,
          'volume-bar-background': true
        })
      }
      return (
        <div {...VolumeWrapProps} >
          <VolumeSlider ControlsStore={this.props.ControlsStore} />
          <MuteToggleButton ControlsStore={this.props.ControlsStore} />
        </div>
      )
    }
}

VolumeController.propTypes={
  ControlsStore: React.PropTypes.object.isRequired
}
VolumeController.defaultProps={
}



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/volume-controller.jsx